/* Cart v1.0 08/11/2023 */

import {writable, derived} from 'svelte/store';

/**
 * {
 *  id,
 *  name,
 *  img,
 *  price,
 *  weight,
 *  count
 * }
 *
 * @type {Writable<{ id, name, img, price, weight, count}[]>}
 */
export const cartItemsStore = writable([]);

/**
 * {
 *  count: number,
 *  sum: number
 * }
 *
 * @type {Readable<{count: number, sum: number}>}
 */
export const cartTotalStore = derived(cartItemsStore, (items) => {

    const total = {
        count: 0,
        sum: 0
    };

    (items || []).forEach(item => {
        total.sum += (item.price * item.count);
        total.count += item.count;
    });

    return total;
})

/**
 *
 * @type {Writable<*[]>}
 */
export const ordersStore = writable([]);

/**
 *
 * @type {Writable<{orderData: string}>}
 */
export const cartInfoStore = writable({orderData: null});


cartItemsStore.subscribe(cartItems => {
    if (cartItems && cartItems.length > 0) {
        saveCart(cartItems);
    }

    cartInfoStore.update(cartInfo => {
        cartInfo.orderData = undefined;
        return cartInfo;
    });
})

export const addToCart = (record, price, priceIndex, modificators = []) => {

    cartItemsStore.update(items => {

        const found = (items || []).findIndex(i =>
            i.id === record.id &&
            i.priceIndex === priceIndex
            // i.modificators === modificators
        );

        if (found === -1) {
            items.push({
                id: record.id,
                priceIndex: priceIndex,
                name: record.name,
                img: (record.media || []).filter(x => x.type === 'photo')[0]?.name,
                count: 1,
                price: price.price,
                weight: price.weight,
                modificators
            });
        }
        else {
            items[found].count++;
        }

        return items;
    });
}

export const removeFromCart = (record, price, priceIndex, modificators = []) => {

    cartItemsStore.update(items => {
        items = (items || []).filter(i =>
            i.id === record.id && i.priceIndex === priceIndex
        // i.modificators === modificators
        );

        if (items.length === 0) {
            saveCart(items);
        }

        return items;
    });
}

export const incrementItemInCart = (record, price, priceIndex, modificators = []) => {

    cartItemsStore.update(items => {

        (items || []).forEach(i => {
            if (i.id === record.id && i.priceIndex === priceIndex) {
                i.count += 1;
            }
        })

        return items;
    });
}

export const decrementItemInCart = (record, price, priceIndex, modificators = []) => {

    cartItemsStore.update(items => {

        let idxToRemove = null;

        (items || []).forEach( (i,idx) => {
            if (i.id === record.id && i.priceIndex === priceIndex) {
                i.count -= 1;
                if (i.count === 0) {
                    idxToRemove = idx;
                }
            }
        });

        if (idxToRemove !== null) {
            items.splice(idxToRemove, 1);
        }

        if (items.length === 0) {
            saveCart(items);
        }

        return items;
    });

}

export const loadCart = () => {

    const cartItemsStr = window.localStorage.getItem('cart');
    try {
        const cartItems = JSON.parse(cartItemsStr);
        cartItemsStore.set(cartItems || []);
    }
    catch (e) {
        console.error('Load cart error', e);
    }
}

const saveCart = (items) => {
    window.localStorage.setItem('cart', JSON.stringify(items));
}

export const confirmOrder = (cartItems) => {

    ordersStore.update(orders => {

        const orderData = [];
        const total = {};
        cartItems.forEach(item => {
            total.sum += (item.price * item.count);
            total.count += item.count;
            orderData.push([item.id, item.priceIndex, item.count].join('-'));
        });

        cartInfoStore.update(cartInfo => {
            cartInfo.orderData = btoa(orderData.join('!'));
            return cartInfo;
        });


        orders.push({
            date: Date.now(),
            cartItems,
            totalSum: total.sum,
            totalCount: total.count
        });

        return orders;
    })
}
